<template>
	<div v-if="!isMobile()" class="pc">
		<div class="imageTextContent">

			<el-card class="box-card" >
				<div class="imgBox" v-show="introduce.imgList.length>0">
					<swiper :options="imageSwiperOption" ref="mySwiper" class="mySwiper">
						<!-- slides -->
						<swiper-slide class="imageItem" v-for="(item,index) in introduce.imgList" :key="index">
							<!-- <el-image :src="item.url" fit="contain" style=" height: 250px; "></el-image> -->
							<img :src="item.url"  class="contain" style="width: 65%; height: 250px" />
							<span style="color: white;">{{item.title}}</span>
						</swiper-slide>
						<!-- Optional controls -->
						<div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div>
						<!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
					</swiper>
				</div>

				<div class="textBox">
					<div class="caption">
						<h2>{{introduce.title}}</h2>
					</div>
					<div class="inner-content" v-html="introduce.content"></div>
				</div>


			</el-card>
		
		</div>
		<div class="buttonBox swiper-container">
			<div class="swiper-wrapper" style="width: 100%;">
				<!-- <el-button class="swiper-slide btn" @click="openIntroduce">{{introduce.buttonTitle}}</el-button> -->
				<el-button class="swiper-slide btn" v-show="proList.length>1" @click="intoProItem(index)" v-for="(item,index) in proList" :key='index'>{{item.buttonTitle}}</el-button>
				<el-button class="swiper-slide btn" @click="openPictureList" v-show="pictureList.length > 0">图片集</el-button>
			</div>
		</div>
	</div>
	<div v-else class="moblie">
		<div class="cardBox">
			<div class="leftCard">
				<el-card class="box-card">

					<!-- 		<div class="swiper-container-image swiper-container-initialized swiper-container-horizontal  swiper-container-ios">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in introduce.imgList" :key="index"><img class="s-s-image" :src="item" /></div>
						</div>
					</div> -->
					<swiper :options="imageSwiperOption" ref="mySwiper">
						<!-- slides -->
						<swiper-slide class="imageItem" v-for="(item,index) in introduce.imgList" :key="index">
							<!-- <el-image :src="item.url" fit="contain" style=" height: 150px; "></el-image> -->
							<div class="imgBgc">
								<img :src="item.url" class="contain" style=" width: 300px;height: 200px; " />
							</div>
							
							<span style="color: white; ">{{item.title}}</span>
						</swiper-slide>
						<!-- Optional controls -->

						<div class="swiper-pagination" slot="pagination"></div>

					</swiper>


				</el-card>
			</div>
			<div class="rightCard">
				<el-card class="box-card">
					<div class="caption">
						<h2>{{introduce.title}}</h2>
					</div>
					<div class="inner-content" v-html="introduce.content"></div>
				</el-card>
			</div>
		</div>
		<div class="phone-menu">
			<ul class="flex-column">
				<!-- <li class="circle "><a class="phone-menu-text" @click="openIntroduce">{{introduce.buttonTitle}}</a></li> -->
				<li class="circle " v-show="proList.length>1" @click.stop="intoProItem(index)" v-for="(item,index) in proList" :key='index'><a class="phone-menu-text">{{item.buttonTitle}}</a></li>
				<li class="circle " v-show="pictureList.length> 0"><a class="phone-menu-text" @click="openPictureList">图片集</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
	import {Decrypt,Encrypt} from '@/common/secret.js'
	import {
		Swiper,
		SwiperSlide
	} from 'vue-awesome-swiper'
	import PictureList from '@/views/exhibition/childrenComponents/PictureList.vue'
	import 'swiper/css/swiper.css'

	export default {
		data() {
			return {
				showPictureList: false,
				introduce: {
					buttonTitle: '',
					title: '',
					content: '',
					imgList: []
				},
				proBtnTitle: [],
				proList: [],
				roomId: 123,
				pictureList: [],
				imageSwiperOption: {
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					//是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
					notNextTick: true,
					//循环
					loop: true,
					//设定初始化时slide的索引
					initialSlide: 0,
					//自动播放
					autoplay: {
						delay: 2000,
						stopOnLastSlide: false,
						/* 触摸滑动后是否继续轮播 */
						disableOnInteraction: false
					},
					//滑动速度
					speed: 800,
					//滑动方向
					direction: "horizontal",
					//小手掌抓取滑动
					grabCursor: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
				}
			}
		},
		components: {
			PictureList,
			Swiper,
			SwiperSlide
		},
		mounted() {
			// 默认加载展厅简介的内容
			// 发送请求获得产品按钮数量和名称
			// --------------
			console.log(this.$store.state.hallId)
			let params = {
				params: {
					roomId: this.$store.state.hallId
				}
			}
			this.$global.axios.get(this.$global.SERVER_OFFLINE ?this.$global.SERVER_SUBFILE +'json/proList.json' : '/api/cloudget/proList', params)
				.then(res => {
					if (res.data.success) {
						console.log(res.data)
						if (res.data.data.length == 0) {
							this.proBtnTitle = []
						} else {
							this.proList = res.data.data
							this.intoProItem(0)
						}
					} else {
						this.$message.error('失败' + res.data.msg)
					}
				})
			this.$global.axios.get(this.$global.SERVER_OFFLINE ?this.$global.SERVER_SUBFILE +'json/pictureList02.json':'/api/cloudget/pictureList', params)
				.then(res => {
					if (res.data.success) {
						console.log(res.data)
						if (res.data.data.rows.length == 0) {
							this.pictureList = []
						} else {
							this.pictureList = res.data.data.rows

						}
					} else {
						this.$message.error('失败' + res.data.msg)
					}
				})
				
			
		},
		methods: {
			isMobile() {
				return navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				);
			},
			searchProList(roomId) {
				// 查询产品列表
				let path = ''
				if(!this.$global.SERVER_OFFLINE) {
					path = '/api/cloudget/proList'
				}else {
					path = this.$global.SERVER_SUBFILE +'json/proList.json'
				}
				
				let params = {
					params: {
						roomId: roomId
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							console.log(res)
						} else {
							this.$message.error('失败' + res.data.msg)
						}
					})
			},
			// searchIntroduce(roomId) {
			// 	// 查询展厅简介
			// 	let path = '/api/cloudget/introduce'
			// 	let params = {
			// 		params: {
			// 			roomId: roomId
			// 		}
			// 	}
			// 	this.$global.axios
			// 		.get(path, params)
			// 		.then(res => {
			// 			if (res.data.success) {
			// 				console.log(res)
			// 				this.introduce.buttonTitle = res.data.data.buttonTitle
			// 				this.introduce.title = res.data.data.title
			// 				this.introduce.content = res.data.data.content
			// 				this.introduce.imgList = []
			// 				let result = res.data.data
			// 				// if (res.data.data.url1 != 'undefined' && res.data.data.url1 != "") {
			// 				// 	this.introduce.imgList.push(res.data.data.url1)
			// 				// }
			// 				// if (res.data.data.url2 != 'undefined' && res.data.data.url2 != "") {
			// 				// 	this.introduce.imgList.push(res.data.data.url2)
			// 				// }
			// 				// if (res.data.data.url3 != 'undefined' && res.data.data.url3 != "") {
			// 				// 	this.introduce.imgList.push(res.data.data.url3)
			// 				// }
			// 				if (result.url1 != 'undefined') {
			// 					this.introduce.imgList.push({
			// 						title: result.title1,
			// 						url: result.url1
			// 					})

			// 				}
			// 				if (result.url2 != 'undefined') {
			// 					this.introduce.imgList.push({
			// 						title: result.title2,
			// 						url: result.url2
			// 					})
			// 				}
			// 				if (result.url3 != 'undefined') {
			// 					this.introduce.imgList.push({
			// 						title: result.title3,
			// 						url: result.url3
			// 					})
			// 				}
			// 			} else {
			// 				this.$message.error('失败' + res.data.msg)
			// 			}
			// 		})
			// },
			searchHotPicture(hotId) {
				// 查询热点图片
				let path = '/api/cloudget/hotPictureDOList'
				let params = {
					params: {
						hotId: hotId
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							console.log(res)
						} else {
							this.$message.error('失败' + res.data.msg)
						}
					})
			},
			searchHotIntroduce(hotId) {
				// 查询图文热点
				let path = '/api/cloudget/hotIntroduce'
				let params = {
					params: {
						hotId: hotId
					}
				}
				this.$global.axios
					.get(path, params)
					.then(res => {
						if (res.data.success) {
							console.log(res)
						} else {
							this.$message.error('失败' + res.data.msg)
						}
					})
			},
			intoProItem(index) {
				console.log(index)
				// 点击产品按钮，将上方内容给为当前产品信息
				this.introduce.title = this.proList[index].title
				this.introduce.content = this.proList[index].content
				this.introduce.imgList = []
				console.log(this.proList[index])
				console.log(this.proList[index].url2)
				console.log(this.proList[index].url3)
				if (this.proList[index].url1 != 'undefined' && this.proList[index].url1) {
					this.introduce.imgList.push({
						title: this.proList[index].title1,
						url: this.proList[index].url1
					})
				}
				if (this.proList[index].url2 != 'undefined' && this.proList[index].url2) {
					this.introduce.imgList.push({
						title: this.proList[index].title2,
						url: this.proList[index].url2
					})
				}
				if (this.proList[index].url3 != 'undefined' && this.proList[index].url3) {
					this.introduce.imgList.push({
						title: this.proList[index].title3,
						url: this.proList[index].url3
					})
				}
				console.log(this.introduce.imgList)


			},
			openPictureList() {
				// 调用外部页面的图片集插件
				var galley = parent.window.document.getElementById('galley');
				var viewer = new Viewer(galley, {
					url: 'data-original',
					toolbar: {},
					title: false,
					hidden: function() {
						viewer.destroy();
					},
				});
				viewer.show();
			},
			// openIntroduce() {
			// 	this.searchIntroduce(this.$store.state.hallId)
			// }
		}
	}
</script>
<style scoped="scoped">
	.inner-content>>> p,li,font{
				color: #fff !important;
	}
	.inner-content {
		padding-bottom: 20px;
	}
</style>
<style lang="less">
	
	.pc {
		
		.swiper-pagination {
			// height: 300px;
			// position: relative;
			bottom: 25px;
			// background-color: red;
		}
		.imgBox {
			padding-bottom: 20px;
			border-bottom: 1px solid #fff;
		}
		.textBox {
			color: white!important;
		}
		.inner-content {
			// position: absolute;
			// left: 20px;
			// top: 100px;
			// right: 20px;
			// bottom: 20px;
			// overflow-x: hidden;
			// height: 360px;
			max-height: 40vh;
			padding: 15px;
			overflow-y: scroll;
			margin-bottom: 10px;
			-ms-overflow-style: none;

			p,
			li {
				font-size: 14px;
				line-height: 25px;
				word-wrap: break-word;
			}

			img {
				object-fit: contain;
				/*position:relative;*/
				// top: 10px;
				// bottom: 30px;
				// left: 0;
				// right: 0;
				// width: 100%;
				// margin: auto;
			}
		}
		
	}

	.imageItem {
		width: 100%;
		
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.moblie {
		.box-card {
			background-color: rgba(0,0,0,0);
			border-color: rgba(0,0,0,0);
		}
		.el-card__body {
			padding: 10px;
		}

		.swiper-pagination {
			bottom: 20px;
		}

		.inner-content {
			// color: #fff !important;
			position: absolute;
			left: 20px;
			top: 60px;
			right: 20px;
			bottom: 20px;
			overflow-x: hidden;
			overflow-y: scroll;
			margin-bottom: 10px;
			
			p,
			li {
				font-size: 14px;
				line-height: 25px;
				word-wrap: break-word;
				// color: #fff !important;
			}

			img {
				/*position:relative;*/
				
				top: 10px;
				bottom: 30px;
				left: 0;
				right: 0;
				width: 100%;
				margin: auto;
			}
		}
	}

	.inner-content::-webkit-scrollbar {
		display: none;
	}
</style>
<style lang="less" scoped>
	.pc {
		
		height: 100vh;
		.imageTextContent {
			// background-color: yellow;
			display: flex;
			flex-direction: column;
			// justify-content: center;
			align-items: center;
			
			height: 100%;
			// background-color: red;

		}
		
		img {
			/*position:relative;*/
			// top: 10px;
			// bottom: 30px;
			// left: 0;
			// right: 0;
			// width: 100%;
			// margin: auto;
			object-fit: contain;
		}
		.swiper-wrapper {
			display: flex;
			// justify-content: space-between;
			justify-content: center;
		}

		.btn {
			min-width: 170px;
			max-width: 170px;
			margin-right: 20px;

		}

		.btn:last-of-type {
			margin-right: 0 !important;
		}

		.cardBox {

			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.leftCard {
			width: 45%;
			min-width: 450px;
			height: 90%;
			position: relative;
			background-color: yellow;
			border-radius: 4px;

			img {
				/*position:relative;*/
				// top: 10px;
				// bottom: 30px;
				// left: 0;
				// right: 0;
				// width: 100%;
				// margin: auto;
				object-fit: contain;
			}
		}

		.rightCard {
			width: 45%;
			min-width: 450px;
			height: 90%;
			position: relative;
			background-color: yellow;
			border-radius: 4px
		}

		.caption {
			padding: 15px 10px;
			margin: 0 30px 10px 30px;
			text-align: center;
			// border-bottom: solid #272122 3px;
		}

		.box-card {
			height: 85vh;
			min-height: 600px;
			min-width: 500px;
			width: 40vw;
			
			// opacity: 0;
			background-color: rgba(0,0,0,0);
			border-color:rgba(0,0,0,0) ;
			box-shadow: none;
		}

		.buttonBox {
			width: 80vw;
			height: 60px;
			display: flex;
			bottom: 15%;
			
		}



		.cover {
			background-color: black;
			position: absolute;
			left: 0px;
			top: 50px;
			width: 100%;
			height: 100%;
			filter: alpha(opacity=80);
			opacity: 0.8;
			position: absolute;
			z-index: 999;
		}
	}

	.moblie {
		margin-top: 10px;
		.imgBgc {
			// background:#fff;
			// height: auto;
		}
		img {
			object-fit: scale-down;
			
			
		}
		.phone-menu {
			position: fixed;
			display: flex;
			top: 40px;
			left: 0px;
			z-index: 999;
		}

		.circle {
			width: 70px;
			height: 40px;
			padding: 2px;
			text-align: center;
			text-rendering: auto;
			text-indent: 0px;
			font-size: 12px;
			line-height: 15px;
			border-radius: 5px;
			border: 1px solid #e11214;
			box-shadow: 0px 3px 10px #00000088;
			margin-top: 20px;
			list-style: none;
			background-color: #fff;
			word-wrap: break-word;
			
			
		}

		.flex-column {
			padding-left: 0;
			
		}

		.phone-menu-text {
			position: relative;
			display: block;
			padding: 10px 1px;
			/* white-space: nowrap; */
			text-decoration: none;
			word-wrap: break-word;
			color: #333;

		}

		.phone-menu-text:hover {
			text-decoration: none;
		}



		.cardBox {
			position: relative;
		}

		.leftCard {
			width: 90%;
			height: 40vh;
			position: relative;
			margin: 0 auto;
			top: 0px;
			
			border-radius: 4px;

			img {
				/*position:relative;*/
				top: 10px;
				bottom: 30px;
				left: 0;
				right: 0;
				width: 100%;
				margin: auto;
			}
			.box-card {
				height: auto;
			}
		}

		.rightCard {
			/*display: table-row;*/
			/*width: 90%;*/
			height: 150%;
			position: absolute;
			margin: 0 auto;
			top: calc(40vh);
			bottom: 20px;
			left: 18px;
			right: 18px;
			// background-color: yellow;
			// color:#fff;
			border-radius: 4px;
		}

		.caption {
			padding: 5px 5px;
			margin: 0 10px 10px 10px;
			text-align: center;
			color: #fff!important;
			// border-bottom: solid #272122 3px;
		}

		.box-card {
			position: absolute;
			width: 100%;
			height: 100%;
			// background-color: ;
			
		}

		.buttonBox {
			width: 70vw;
			height: 60px;
			display: flex;

		}

		.buttonBox .el-button {

			margin-right: 10px;
		}

		.cover {
			background-color: black;
			position: absolute;
			left: 0px;
			top: 50px;
			width: 100%;
			height: 100%;
			filter: alpha(opacity=80);
			opacity: 0.8;
			position: absolute;
			z-index: 999;
		}
	}
</style>
